import { makeMetadataPayload } from '@wework/www-form-utils';
import { getFutureMonth } from './date';
import { geoData } from './geo';
import { getSelectedLocale } from './util/locale';

export async function getDefaultLeadsFormData(leadSourceDetail) {
  const mixpanelId = window.mixpanel ? window.mixpanel.get_distinct_id() : '';
  const { countryCode } = await geoData;

  // this is a a www-website-ism
  const segmentId = window.analyticsGlobals.userId;
  const locale = getSelectedLocale();

  return {
    ...makeMetadataPayload({
      locale
    }),
    lead_source_detail: leadSourceDetail,
    country_code: countryCode,
    heap_should_track: true,
    lead_source: 'WeWork.com',
    sales_flow: 'wework',
    app_version: '7.0.0',
    mixpanel_id: mixpanelId,
    segment_id: segmentId,
    create_source: 'contentful'
  };
}

const monthIndexMap = {
  thisMonth: 0,
  nextMonth: 1,
  other: 2
};

const getLeadSourceSubtype = (leadFormData, building, isTourFormCompleted) => {
  const { desiredCapacity, isDeskAvailable } = leadFormData;
  const BUILDING_STATUS = {
    CONSULTATION_BUILDING_INTEREST: 'Consultation - Building Interest',
    WAITLIST_BUILDING: 'Waitlist - Building',
    TOUR_BOOKED_BUILDING_INTEREST: 'Tour Booked - Building Interest',
    TOUR_BUILDING_INTEREST: 'Tour - Building Interest'
  };

  const isTourFormFilledAndDesiredCapacityStatus = (() => {
    if (Number(desiredCapacity) > 10) {
      return BUILDING_STATUS.CONSULTATION_BUILDING_INTEREST;
    }
    return isTourFormCompleted ? BUILDING_STATUS.TOUR_BOOKED_BUILDING_INTEREST : BUILDING_STATUS.TOUR_BUILDING_INTEREST;
  })();

  const buildingStatusMap = {
    IS_OPEN: {
      true: {
        IS_TOURABLE: {
          true: {
            IS_FULL: {
              true: undefined,
              false: isTourFormFilledAndDesiredCapacityStatus
            }
          },
          false: {
            IS_FULL: {
              true: BUILDING_STATUS.WAITLIST_BUILDING,
              false: BUILDING_STATUS.WAITLIST_BUILDING
            }
          }
        }
      },
      false: {
        IS_TOURABLE: {
          true: {
            IS_FULL: {
              true: undefined,
              false: isTourFormFilledAndDesiredCapacityStatus
            }
          },
          false: {
            IS_FULL: {
              true: undefined,
              false: BUILDING_STATUS.WAITLIST_BUILDING
            }
          }
        }
      }
    }
  };
  let leadSourceSubtype =
    buildingStatusMap.IS_OPEN[building.is_open].IS_TOURABLE[building.is_tourable].IS_FULL[building.is_full] || '';

  if (isDeskAvailable !== undefined && building.is_open && !isDeskAvailable) {
    leadSourceSubtype = BUILDING_STATUS.CONSULTATION_BUILDING_INTEREST;
  }

  return leadSourceSubtype;
};

export function getFormattedMoveInDate(moveInDateString) {
  const monthIndex = monthIndexMap[moveInDateString];
  if (monthIndex === undefined) {
    return moveInDateString;
  }
  const futureMonth = getFutureMonth(monthIndex);
  const currentMonthIndex = new Date().getMonth();
  const now = new Date();
  const year = futureMonth.index < currentMonthIndex ? now.getFullYear() + 1 : now.getFullYear();
  return `${year}-${futureMonth.formatted}-01`;
}

export function makeLeadServiceRequest(leadFormData, building, step, sendLeadSourceSubtype = true) {
  const isTour = !!(leadFormData.tourDate && leadFormData.tourTimes);

  // Google Analytics info to be sent to Salesforce
  let clientId;

  if (window.ga) {
    const tracker = window.ga.getAll()[0];
    clientId = tracker.get('clientId');
  }

  const trackingId = 'UA-4260314-5';

  return {
    google_analytics: {
      gaclientid: clientId,
      gatrackid: trackingId
    },
    contact_name: leadFormData.contact_name,
    email: leadFormData.email,
    phone: leadFormData.phone,
    notes: leadFormData.notes,
    move_in_date: getFormattedMoveInDate(leadFormData.moveInDate),
    company_size: leadFormData.desiredCapacity,
    marketing_consent: leadFormData.marketing_consent,
    ...(step === 1 && {
      desired_capacity: leadFormData.desiredCapacity,
      move_in_time_frame: leadFormData.moveInDate,
      submission_type: 'lead'
    }),
    interests: {
      building_ids: [building.id]
    },
    ...(leadFormData.company_name && {
      company_name: leadFormData.company_name
    }),
    ...(step === 2 && {
      submission_type: isTour ? 'tour' : 'lead',
      company_name: leadFormData.company_name,
      promo_code: leadFormData.promoCode,
      notes: leadFormData.notes,
      ...(isTour && {
        tour: {
          building_id: building.id,
          date: leadFormData.tourDate,
          time: leadFormData.tourTimes.replace(/\s/g, ''), // Remove space in "10:00 AM"
          notes: leadFormData.notes
        }
      })
    }),
    lead_source_subtype: sendLeadSourceSubtype ? getLeadSourceSubtype(leadFormData, building, isTour) : ''
  };
}
